import { render, staticRenderFns } from "./vue-breadcrumbs.vue?vue&type=template&id=64e1a86e&scoped=true&"
import script from "./vue-breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./vue-breadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./vue-breadcrumbs.vue?vue&type=style&index=0&id=64e1a86e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e1a86e",
  null
  
)

export default component.exports